export enum ActivityFieldEnum {
  None,
  Production,
  Service,
  Investment,
  Insurance,
  Bank,
  Leasing,
  MassConstruction,
  InvestmentFund,
}

export enum MarketEnum {
  Bourse = 1,
  Farabourse,
  BaseMarket, // Bazar Payeh
}

export enum ComponentTypeEnum {
  None,
  CompanyInfo, // اطلاعات شرکت
  ProductPieChart, // نمودار محصولات
  InternalAndExternalSellChart, // نمودار فروش داخلی صادراتی
  MonthlySellCompareChart, // نمودار مقایسه فروش ماهانه
  ProfitabilityCompareChart, // نمودار مقایسه فصلی حاشیه سود ناخالص
  SalesGrowth, // رشد فروش
  ProfitabilityGrowth, // رشد سودآوری و درآمدهای عملیاتی
  ProfitMargin, // حاشیه سود
}

export enum SourceUrlTypeEnum {
  None,
  Tsetmc,
  Codal,
  Codal360,
  Pdf,
  Excel,
  Attachment,
  Tedan,
  Xbrl,
  TsetmcApi,
}

export enum MarketStatus {
  Close,
  Open,
}

export enum StatGroup {
  None,
  MpProduction,
  FsProfitAndLoss,
  MpService,
  OieProduction,
  OieService,
}

export enum StatType {
  None,

  LastMonthlySaleGrowthToSameMonthOfPreviousYear,
  LastMonthlySaleGrowthToPreviousMonth,
  LastMonthlySaleGrowthToLastYearAverage,
  LastMonthlySaleGrowthToPreviousYearAverage,
  LastMonthlySaleGrowthToTwelveMonthsAgo,

  LastYearAverageMonthlySalesGrowthToSamePeriodPreviousYearAverage,
  LastYearAverageMonthlySalesRatioToPreviousYearAverage,
  LastYearAverageMonthlySalesGrowthToPreviousYearAverage,
  LastYearAverageMonthlySalesGrowthToPreviousTwoYearAverage,

  LastSeasonAverageMonthlySalesGrowthToPreviousSeason,
  LastSeasonAverageMonthlySalesGrowthToSameSeasonOfPreviousYear,

  LastSeasonGrossProfitMargin,
  LastSeasonOperatingProfitMargin,
  LastSeasonNetProfitMargin,

  LastPeriodGrossProfitMargin,
  LastPeriodOperatingProfitMargin,
  LastPeriodNetProfitMargin,

  LastFourSeasonGrossProfitMarginAverage,
  LastFourSeasonOperatingProfitMarginAverage,
  LastFourSeasonNetProfitMarginAverage,

  LastFiveYearGrossProfitMarginAverage,
  LastFiveYearOperatingProfitMarginAverage,
  LastFiveYearNetProfitMarginAverage,

  LastSeasonOperatingIncomeGrowthToPreviousSeason,
  LastSeasonGrossProfitGrowthToPreviousSeason,
  LastSeasonOperatingProfitGrowthToPreviousSeason,
  LastSeasonNetProfitGrowthToPreviousSeason,

  LastSeasonOperatingIncomeGrowthToSameSeasonOfPreviousYear,
  LastSeasonGrossProfitGrowthToSameSeasonOfPreviousYear,
  LastSeasonOperatingProfitGrowthToSameSeasonOfPreviousYear,
  LastSeasonNetProfitGrowthToSameSeasonOfPreviousYear,

  LastSeasonOperatingIncomeGrowthToPreviousFourSeasonAverage,
  LastSeasonGrossProfitGrowthToPreviousFourSeasonAverage,
  LastSeasonOperatingProfitGrowthToPreviousFourSeasonAverage,
  LastSeasonNetProfitGrowthToPreviousFourSeasonAverage,

  LastPeriodOperatingIncomeGrowthToSamePeriodOfPreviousYear,
  LastPeriodGrossProfitGrowthToSamePeriodOfPreviousYear,
  LastPeriodOperatingProfitGrowthToSamePeriodOfPreviousYear,
  LastPeriodNetProfitGrowthToSamePeriodOfPreviousYear,

  TtmMpSell,

  LastMonthlyIncomeGrowthToSameMonthOfPreviousYear,
  LastMonthlyIncomeGrowthToPreviousMonth,
  LastMonthlyIncomeGrowthToLastYearAverage,
  LastMonthlyIncomeGrowthToPreviousYearAverage,
  LastMonthlyIncomeGrowthToTwelveMonthsAgo,

  LastYearAverageMonthlyIncomesGrowthToSamePeriodPreviousYearAverage,
  LastYearAverageMonthlyIncomesRatioToPreviousYearAverage,
  LastYearAverageMonthlyIncomesGrowthToPreviousYearAverage,
  LastYearAverageMonthlyIncomesGrowthToPreviousTwoYearAverage,

  LastSeasonAverageMonthlyIncomesGrowthToPreviousSeason,
  LastSeasonAverageMonthlyIncomesGrowthToSameSeasonOfPreviousYear,

  TtmMpIncome,

  LastSeasonAverageMonthlySalesGrowthToPreviousFourSeasonAverage,
  LastSeasonAverageMonthlyIncomesGrowthToPreviousFourSeasonAverage,
}

export enum FsType {
  None,
  ProfitAndLoss,
  BalanceSheet,
  CashFlow,
  ConsolidatedProfitAndLoss,
  ConsolidatedBalanceSheet,
  ConsolidatedCashFlow,
}

export enum Period {
  Trimester = 3,
  SixMonths = 6,
  NineMonths = 9,
  TwelveMonths = 12,
}

export enum AnnouncementType {
  None,
  MonthlyPerformance,
  FinancialStatement,
  InvestmentMonthlyPerformance,
}

export enum AnnouncementContainedObjectsEnum {
  None = 0,
  MonthlyPerformance = 1,
  CumulativeMonthlyPerformance = 8192,
  ProfitAndLoss = 2,
  BalanceSheet = 4,
  CashFlow = 8,
  ConsolidatedProfitAndLoss = 16,
  ConsolidatedBalanceSheet = 32,
  ConsolidatedCashFlow = 64,
  ImpInvestmentsSummary = 128,
  ImpInBoursePortfolio = 256,
  ImpOutBoursePortfolio = 512,
  ImpEarnedStockDetails = 1024,
  ImpTransferredStockDetails = 2048,
  ImpDividendIncome = 4096,
  OperatingIncomeAndExpense = 16384,
  Cost = 32768,
  OaCost = 65536,
  InventoryTurnover = 131072,
  InventoryTurnoverEstimated = 262144,
  PcRawMaterial = 524288,
  PcRawMaterialEstimated = 1048576,
  Dps = 2097152,
  MonthlyEnergy = 4194304,
  CumulativeMonthlyEnergy = 8388608,
  MonthlyRawMaterial = 16777216,
  CumulativeMonthlyRawMaterial = 33554432,
  FcFlow = 67108864,
  CumulativeFcFlow = 134217728,
  InvestmentReport = 268435456,
}

export enum AnnouncementErrorTypeEnum {
  None,
  AnnouncementOutOfDate,
  DocumentLoadingFailed,
  IncorrectSheetId,
  ScrappingFailed,
  ValidationWarning,
  ValidationError,
  UnknownSymbol,
  IncorrectActivityField,
  CreateError,
  UpdateError,
  Exception,
  ObjectDeleted,
  MonthlyCacheRefreshFailed = 13,
  MonthlyCacheRefreshPending = 14,
}

export enum AnnouncementErrorTypeFlag {
  None = 0,
  AnnouncementOutOfDate = 1,
  DocumentLoadingFailed = 2,
  IncorrectSheetId = 4,
  ScrappingFailed = 8,
  ValidationWarning = 16,
  ValidationError = 32,
  UnknownSymbol = 64,
  IncorrectActivityField = 128,
  CreateError = 256,
  UpdateError = 512,
  Exception = 1024,
  ObjectDeleted = 2048,
  MonthlyCacheRefreshFailed = 4096,
  MonthlyCacheRefreshPending = 8192,
}

export enum FsItemKind {
  Simple,
  Description,
  Group,
}

export enum FsItemMark {
  None,
  Mark1,
  Mark2,
  Mark3,
  Mark4,
  Mark5,
  Mark6,
  Mark7,
  Mark8,
  Mark9,
  Mark10,
  Mark11,
  Mark12,
  Mark13,
  Mark14,
  Mark15,
  Mark16,
  Mark17,
  Mark18,
  Mark19,
  Mark20,
  Mark21,
  Mark22,
  Mark23,
  Mark24,
  Mark25,
  Mark26,
  Mark27,
  Mark28,
  Mark29,
  Mark30,
  Mark31,
  Mark32,
  Mark33,
  Mark34,
  Mark35,
  Mark36,
  Mark37,
  Mark38,
  Mark39,
  Mark40,
  Mark41,
  Mark42,
  Mark43,
  Mark44,
  Mark45,
  Mark46,
  Mark47,
  Mark48,
  Mark49,
  Mark50,
  Mark51,
  Mark52,
  Mark53,
  Mark54,
  Mark55,
  Mark56,
  Mark57,
  Mark58,
  Mark59,
  Mark60,
  Mark61,
  Mark62,
  Mark63,
  Mark64,
  Mark65,
  Mark66,
  Mark67,
  Mark68,
  Mark69,
  Mark70,
  Mark71,
  Mark72,
  Mark73,
  Mark74,
  Mark75,
  Mark76,
  Mark77,
  Mark78,
  Mark79,
  Mark80,
  Mark81,
  Mark82,
  Mark83,
  Mark84,
  Mark85,
  Mark86,
  Mark87,
  Mark88,
  Mark89,
  Mark90,
  Mark91,
  Mark92,
  Mark93,
  Mark94,
  Mark95,
  Mark96,
  Mark97,
  Mark98,
  Mark99,
  Mark100,
}

export enum CostItemKind {
  Simple,
  Description,
}

export enum CostItemMark {
  None,
  Mark1,
  Mark2,
  Mark3,
  Mark4,
  Mark5,
  Mark6,
  Mark7,
  Mark8,
  Mark9,
  Mark10,
  Mark11,
  Mark12,
  Mark13,
  Mark14,
  Mark15,
  Mark16,
  Mark17,
  Mark18,
  Mark19,
  Mark20,
}

export enum DpsItemKind {
  Simple,
  Description,
}

export enum DpsItemMark {
  None,
  Mark1,
  Mark2,
  Mark3,
  Mark4,
  Mark5,
  Mark6,
  Mark7,
  Mark8,
  Mark9,
  Mark10,
  Mark11,
  Mark12,
  Mark13,
  Mark14,
  Mark15,
  Mark16,
  Mark17,
  Mark18,
  Mark19,
  Mark20,
}

export enum OacItemKind {
  Simple,
  Description,
}

export enum OacItemMark {
  None,
  Mark1,
  Mark2,
  Mark3,
  Mark4,
  Mark5,
  Mark6,
  Mark7,
  Mark8,
  Mark9,
  Mark10,
  Mark11,
  Mark12,
  Mark13,
  Mark14,
  Mark15,
  Mark16,
  Mark17,
  Mark18,
  Mark19,
  Mark20,
}

export enum MpItemKind {
  Simple,
  Others,
  SumInternal,
  SumExport,
  SumService,
  SumReturned,
  Discount,
  SumTotal,
  AgriFairValue,
  AgriNetFairValue,
  AgriImputedCost,
}

export enum SellType {
  None,
  Internal,
  Export,
  Service,
  Returned,
}

export enum MpsItemKind {
  Simple,
  Others,
  Discount,
  SumTotal,
}

export enum MeItemKind {
  Simple,
  SumTotal,
}

export enum EnergyClassification {
  None,
  Fuel,
  Feedstock,
}

export enum AnnouncementCategoryEnum {
  None,
  AnnualInformationAndFinancialStatements = 1,
  MonthlyPerformanceReport = 3,
  MeetingsAndDecisions = 6,
}

export enum AnnouncementLetterTypeEnum {
  None,
  InterimFinancialInformationAndStatements = 6,
  MonthlyActivityReport = 58,
  OrdinaryAnnualDecisions = 20,
}

export enum GlanceStatus {
  None,
  Allowed,
  AllowedReserved,
  AllowedStop,
  Forbidden,
  ForbiddenStop,
}

export enum GlanceHistoryType {
  Trades,
  Clients,
  EpsAndPe,
}

export enum GlanceAdjustmentTypeEnum {
  Unadjusted,
  CapitalIncrease,
  CapitalIncreaseAndCashProfit,
}

export enum ShareholderEnterLeaveEnum {
  Enter,
  Leave,
}

export enum ItItemKindEnum {
  Simple,
  Others,
  SumTotal,
}

export enum PcRmItemTypeEnum {
  None,
  Internal,
  Import,
}

export enum PcRmItemKindEnum {
  Simple,
  Others,
  SumInternal,
  SumImport,
  SumTotal,
}

export enum FcFlowItemTypeEnum {
  Sources,
  Uses,
}

export enum FcFlowItemKindEnum {
  Simple,
  Others,
  SumSources,
  SumUses,
}
